import { Box, Button, Text, useToast } from '@chakra-ui/react';
import { useDownloadSuzukiGarantiePro } from '../../../../state/server-side/queries/carolive-v3';
import { FaFilePdf } from 'react-icons/fa';
import { saveAs } from 'file-saver';

export const SuzukiGarantieProInfo = ({ order }) => {
	const toast = useToast();
	const mutation = useDownloadSuzukiGarantiePro();

	const vin = order.vin;
	if (!vin || order.idMarca !== 266) return null;

	const handleClick = () => {
		mutation.mutate(
			{ devizId: order.id },
			{
				onSuccess: data => {
					saveAs(data, `garantia_suzuki_pro_${order.id}.pdf`);
				},
				onError: error => {
					console.log({ error });
					toast({
						title: 'Eroare!',
						description: error.message,
						status: 'error',
						duration: 5000,
						isClosable: true,
					});
				},
			}
		);
	};

	return (
		<Box maxW={{ base: '100%', xl: '50%' }}>
			<Text fontWeight={'bold'} fontSize={'lg'}>
				Garantia Suzuki Pro
			</Text>
			{/* <pre>{JSON.stringify(recalls, null, 2)}</pre> */}
			<Box display={'flex'} flexDir={'column'} gap={2}>
				<Button onClick={handleClick} isLoading={mutation.isLoading} leftIcon={<FaFilePdf />}>
					Download PDF
				</Button>
			</Box>
		</Box>
	);
};
